import { render, staticRenderFns } from "./buyAgreement.vue?vue&type=template&id=470cb78a&scoped=true&"
import script from "./buyAgreement.vue?vue&type=script&lang=js&"
export * from "./buyAgreement.vue?vue&type=script&lang=js&"
import style0 from "./buyAgreement.vue?vue&type=style&index=0&id=470cb78a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "470cb78a",
  null
  
)

export default component.exports